<h4 *ngIf="reportItem.title">
    {{ reportItem.title.fullLabel }}
    <app-tooltip data-html2canvas-ignore *ngIf="reportItem.title.summary" [text]="reportItem.title.summary"></app-tooltip>
</h4>

<div class="chart-container">
    <section [ngClass]="{alone: !labelsArray || !labelsArray.length}">
        <canvas #canvas></canvas>
    </section>

    <section *ngIf="labelsArray && labelsArray.length">
        <mat-list class="labels-list">
            <mat-list-item *ngFor="let label of labelsArray; index as i">
                <span class="label">
                    <span class="color-box" [ngStyle]="{'background-color': colors[i]}"></span>{{ label }}
                </span>
            </mat-list-item>
        </mat-list>
    </section>
</div>
